module.exports = __webpack_public_path__ + "static/print_wiffi-5042c76f3ef79f60213b95131347beb2.png";